import { render } from "./Role.vue?vue&type=template&id=7b0372f8&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"

import "./Role.vue?vue&type=style&index=0&id=7b0372f8&scoped=true&lang=css"
import "./Role.vue?vue&type=style&index=1&id=7b0372f8&lang=css"

import exportComponent from "D:\\PRG\\gitEE\\wwj\\web\\htweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0372f8"]])

export default __exports__